(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ark-cosmic-hero"] && !Shopify.designMode) return;
  try {
    
  // Orbit Field pointer parallax: the showcase card tilts toward the cursor,
  // the orbit backdrop drifts the opposite way. Hover-capable devices only;
  // fully inert under prefers-reduced-motion.
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.querySelectorAll('.ark-cosmic[data-parallax="true"]').forEach(function (root) {
      var card = root.querySelector('.ark-pcard');
      var field = root.querySelector('.ark-cosmic__field');
      var far = root.querySelector('.ark-cosmic__field-far');
      if (!card && !field && !far) return;
      var raf = null;
      var mx = 0;
      var my = 0;
      function apply() {
        raf = null;
        if (card) {
          card.style.transform =
            'perspective(90rem) rotateY(' + (mx * 7).toFixed(2) + 'deg) rotateX(' + (my * -5).toFixed(2) + 'deg)';
        }
        if (field) {
          field.style.transform =
            'translate3d(' + (mx * -16).toFixed(1) + 'px, ' + (my * -12).toFixed(1) + 'px, 0)';
        }
        // far stars drift at ~0.4x of the field: distant objects move less
        if (far) {
          far.style.transform =
            'translate3d(' + (mx * -6).toFixed(1) + 'px, ' + (my * -5).toFixed(1) + 'px, 0)';
        }
      }
      root.addEventListener('pointermove', function (e) {
        var r = root.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - r.top) / r.height - 0.5;
        if (!raf) raf = requestAnimationFrame(apply);
      });
      root.addEventListener('pointerleave', function () {
        if (card) card.style.transform = '';
        if (field) field.style.transform = '';
        if (far) far.style.transform = '';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ark-email-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var dialog = document.getElementById('ark-popup');
    if (!dialog || typeof dialog.showModal !== 'function') {
      return;
    }

    var SEEN_KEY = 'ark_popup_seen';

    function markSeen() {
      try {
        localStorage.setItem(SEEN_KEY, '1');
      } catch (e) {}
    }

    function hasSeen() {
      try {
        return !!localStorage.getItem(SEEN_KEY);
      } catch (e) {
        return false;
      }
    }

    // Trigger teardown registry.
    var delayTimer = null;
    var scrollFired = false;
    var triggersDetached = false;

    function detachTriggers() {
      if (triggersDetached) {
        return;
      }
      triggersDetached = true;
      if (delayTimer) {
        window.clearTimeout(delayTimer);
        delayTimer = null;
      }
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onMouseOut);
    }

    function openDialog() {
      if (!dialog.open) {
        try {
          dialog.showModal();
        } catch (e) {}
      }
      paintFoil();
    }

    function openOnce() {
      if (hasSeen()) {
        detachTriggers();
        return;
      }
      openDialog();
      markSeen();
      detachTriggers();
    }

    function onScroll() {
      if (scrollFired) {
        return;
      }
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      if (pct >= scrollPercent) {
        scrollFired = true;
        openOnce();
      }
    }

    function onMouseOut(e) {
      if (e.clientY <= 0) {
        openOnce();
      }
    }

    // Close handling.
    var closeBtns = dialog.querySelectorAll('[data-ark-popup-close]');
    Array.prototype.forEach.call(closeBtns, function (btn) {
      btn.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    dialog.addEventListener('close', markSeen);

    // ---- Scratch-card flow ----
    var SCRATCH_KEY = 'ark_scratch_state';
    var flow = dialog.querySelector('[data-ark-scratch-flow]');
    var foilPainted = false;
    var paintFoil = function () {};

    if (flow) {
      var card = flow.querySelector('.ark-scratch');
      var canvas = flow.querySelector('.ark-scratch__foil');
      var stepScratch = flow.querySelector('[data-ark-step="scratch"]');
      var stepClaim = flow.querySelector('[data-ark-step="claim"]');
      var claimShown = false;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var getScratchState = function () {
        try { return localStorage.getItem(SCRATCH_KEY); } catch (e) { return null; }
      };
      var setScratchState = function (v) {
        try { localStorage.setItem(SCRATCH_KEY, v); } catch (e) {}
      };

      // Sequenced reveal: foil melts + prize glows first, then the claim step
      // slides in. `instant` skips the choreography (state restore / no-motion).
      var showClaim = function (focusEmail, instant) {
        if (claimShown) return;
        claimShown = true;
        card.classList.add('ark-scratch--revealed');
        setScratchState('scratched');
        // Once they've scratched, the reward is "theirs" — remove the exit nudge.
        var dismiss = flow.querySelector('.ark-popup__dismiss');
        if (dismiss) dismiss.hidden = true;
        var finish = function () {
          stepScratch.hidden = true;
          stepClaim.hidden = false;
          if (!instant && !reducedMotion) stepClaim.classList.add('ark-step-enter');
          if (focusEmail) {
            var email = stepClaim.querySelector('input[type="email"]');
            if (email) email.focus({ preventScroll: true });
          }
        };
        if (instant || reducedMotion) {
          finish();
        } else {
          window.setTimeout(finish, 700);
        }
      };

      // Restore: prior scratch, or a failed submit (errors render in the claim step).
      if (getScratchState() === 'scratched' || flow.querySelector('.ark-popup__errors')) {
        showClaim(false, true);
      } else if (canvas && canvas.getContext) {
        var ctx = canvas.getContext('2d');
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var drawing = false;
        var revealed = false;
        var moveCount = 0;

        paintFoil = function () {
          if (foilPainted || !dialog.open) return;
          var rect = card.getBoundingClientRect();
          if (rect.width === 0) return;
          canvas.width = Math.round(rect.width * dpr);
          canvas.height = Math.round(rect.height * dpr);
          var g = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
          g.addColorStop(0, '#8A76CE');
          g.addColorStop(1, '#23204A');
          ctx.fillStyle = g;
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.fillStyle = 'rgba(14, 11, 30, 0.25)';
          for (var i = 0; i < 140; i++) {
            var x = (i * 97) % canvas.width;
            var y = (i * 61) % canvas.height;
            ctx.fillRect(x, y, 2 * dpr, 2 * dpr);
          }
          ctx.fillStyle = '#F4C07A';
          ctx.font = '700 ' + Math.round(15 * dpr) + 'px Arial, sans-serif';
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText('S C R A T C H   M E', canvas.width / 2, canvas.height / 2);
          foilPainted = true;
        };

        var brush = window.matchMedia('(pointer: coarse)').matches ? 36 : 26;
        var lastX = null;
        var lastY = null;

        var scratchAt = function (clientX, clientY) {
          var rect = canvas.getBoundingClientRect();
          var x = (clientX - rect.left) * (canvas.width / rect.width);
          var y = (clientY - rect.top) * (canvas.height / rect.height);
          ctx.globalCompositeOperation = 'destination-out';
          // Stroke from the previous point so fast finger swipes leave a
          // continuous track instead of dotted circles.
          if (lastX !== null) {
            ctx.lineWidth = brush * 2 * dpr;
            ctx.lineCap = 'round';
            ctx.beginPath();
            ctx.moveTo(lastX, lastY);
            ctx.lineTo(x, y);
            ctx.stroke();
          }
          ctx.beginPath();
          ctx.arc(x, y, brush * dpr, 0, Math.PI * 2);
          ctx.fill();
          lastX = x;
          lastY = y;
        };

        var clearedFraction = function () {
          var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
          var cleared = 0;
          var total = 0;
          for (var i = 3; i < data.length; i += 64) {
            total++;
            if (data[i] === 0) cleared++;
          }
          return total ? cleared / total : 0;
        };

        var maybeReveal = function () {
          if (revealed) return;
          if (clearedFraction() >= 0.5) {
            revealed = true;
            showClaim(true);
          }
        };

        // iOS: pointer preventDefault alone doesn't always stop the page/dialog
        // rubber-band scroll once a drag starts — block touchmove explicitly.
        canvas.addEventListener('touchmove', function (e) {
          e.preventDefault();
        }, { passive: false });

        canvas.addEventListener('pointerdown', function (e) {
          drawing = true;
          try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
          // Generous first-contact splash so the very first touch visibly works.
          var rect = canvas.getBoundingClientRect();
          var x = (e.clientX - rect.left) * (canvas.width / rect.width);
          var y = (e.clientY - rect.top) * (canvas.height / rect.height);
          ctx.globalCompositeOperation = 'destination-out';
          ctx.beginPath();
          ctx.arc(x, y, brush * 1.6 * dpr, 0, Math.PI * 2);
          ctx.fill();
          scratchAt(e.clientX, e.clientY);
          e.preventDefault();
        });
        canvas.addEventListener('pointermove', function (e) {
          if (!drawing) return;
          scratchAt(e.clientX, e.clientY);
          moveCount++;
          if (moveCount % 4 === 0) maybeReveal();
          e.preventDefault();
        });
        canvas.addEventListener('pointerup', function () {
          drawing = false;
          lastX = null;
          lastY = null;
          maybeReveal();
        });
        canvas.addEventListener('pointercancel', function () {
          drawing = false;
          lastX = null;
          lastY = null;
        });
        // Keyboard / screen-reader path: the canvas is a focusable button.
        canvas.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            revealed = true;
            showClaim(true);
          }
        });
      } else if (canvas) {
        // No canvas support: skip straight to the claim step.
        canvas.style.display = 'none';
        showClaim(false, true);
      }
    }

    // ---- Copy-code buttons (server-rendered and AJAX success states) ----
    Array.prototype.forEach.call(dialog.querySelectorAll('[data-ark-copy]'), function (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = copyBtn.getAttribute('data-ark-copy');
        var done = function () {
          var prev = copyBtn.textContent;
          copyBtn.textContent = 'Copied ✓';
          window.setTimeout(function () { copyBtn.textContent = prev; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });

    // Fresh signup completed via full-page fallback — clear scratch state.
    if (dialog.querySelector('.ark-popup__success[data-ark-posted]')) {
      try { localStorage.removeItem(SCRATCH_KEY); } catch (e) {}
    }

    // ---- Success auto-close: 30s countdown, any click inside resets it ----
    var countdownTimer = null;
    var startAutoclose = function (root) {
      var line = root.querySelector('[data-ark-countdown]');
      if (!line) return;
      var num = line.querySelector('[data-ark-count]');
      var remaining = 30;
      var render = function () {
        if (num) num.textContent = remaining;
      };
      line.hidden = false;
      render();
      if (countdownTimer) window.clearInterval(countdownTimer);
      countdownTimer = window.setInterval(function () {
        remaining--;
        if (remaining <= 0) {
          window.clearInterval(countdownTimer);
          countdownTimer = null;
          if (dialog.open) dialog.close();
          return;
        }
        render();
      }, 1000);
      root.addEventListener('click', function () {
        remaining = 30;
        render();
      });
    };

    // ---- AJAX signup: submit in the background, swap to success in place.
    // Avoids the full page reload + anchor scroll-jump of the native post.
    // Falls back to the native submit on captcha challenge or any ambiguity.
    var successTpl = dialog.querySelector('[data-ark-success]');
    var ajaxForm = dialog.querySelector('.ark-popup__form');
    if (ajaxForm && successTpl && window.fetch) {
      var ajaxBypass = false;

      var showAjaxSuccess = function () {
        ajaxForm.hidden = true;
        var oldHeading = document.getElementById('ark-popup-heading');
        if (oldHeading) oldHeading.removeAttribute('id');
        successTpl.hidden = false;
        var h = successTpl.querySelector('h2');
        if (h) {
          h.id = 'ark-popup-heading';
          h.focus({ preventScroll: true });
        }
        try { localStorage.removeItem(SCRATCH_KEY); } catch (e) {}
        markSeen();
        startAutoclose(successTpl);
      };

      ajaxForm.addEventListener('submit', function (e) {
        if (ajaxBypass) return;
        e.preventDefault();

        var submitBtn = ajaxForm.querySelector('[type="submit"]:not([hidden])');
        var restoreLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Claiming…';
        }

        var fallbackToNative = function () {
          ajaxBypass = true;
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = restoreLabel;
          }
          ajaxForm.submit();
        };

        // URLSearchParams, not FormData: the endpoint expects the native form's
        // urlencoded body and rejects multipart with a 400 "invalid parameters".
        fetch(ajaxForm.action, {
          method: 'POST',
          body: new URLSearchParams(new FormData(ajaxForm)),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        })
          .then(function (res) {
            if (res.url.indexOf('customer_posted=true') !== -1) {
              showAjaxSuccess();
              return;
            }
            if (res.url.indexOf('challenge') !== -1) {
              fallbackToNative();
              return;
            }
            // Same-URL 200 can still be a challenge page — sniff before trusting.
            return res.text().then(function (html) {
              if (!res.ok || html.indexOf('shopify-challenge') !== -1 || html.indexOf('captcha') !== -1) {
                fallbackToNative();
              } else {
                showAjaxSuccess();
              }
            });
          })
          .catch(fallbackToNative);
      });
    }

    var nativeForm = dialog.querySelector('.ark-popup__form');
    if (nativeForm) {
      nativeForm.addEventListener('submit', markSeen);
    }

    var formMode = dialog.getAttribute('data-form-mode');

    // Native success state: open immediately on return from customer form post.
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      openDialog();
      markSeen();
      detachTriggers();
      var postedSuccess = dialog.querySelector('.ark-popup__success[data-ark-posted]');
      if (postedSuccess) startAutoclose(postedSuccess);
      return;
    }

    // GHL submit detection.
    if (formMode === 'ghl') {
      var expectedOrigin = dialog.getAttribute('data-ghl-origin') || '';
      var autoclose = parseFloat(dialog.getAttribute('data-autoclose'));
      if (isNaN(autoclose) || autoclose < 0) {
        autoclose = 0;
      }

      function isGhlSubmit(data) {
        try {
          if (!data) return false;
          if (typeof data === 'string') return /form[-_ ]?submit|submitted|booking-complete|msgsndr-booking-complete/i.test(data);
          if (Array.isArray(data)) {
            var joined = data.map(function (x) { return typeof x === 'string' ? x : JSON.stringify(x); }).join(' ');
            if (/booking-complete|form[-_ ]?submit|submitted/i.test(joined)) return true;
            if (/"email"|"full_name"|"customer_id"/i.test(joined)) return true;
            return false;
          }
          if (typeof data === 'object') {
            var t = (data.type || data.event || data.action || '') + '';
            if (/resize|height|scroll/i.test(t)) return false;
            if (/form[-_ ]?submit|submitted|complete/i.test(t)) return true;
            if (data.email || data.contact || (data.formId && data.submitted)) return true;
          }
        } catch (e) {}
        return false;
      }

      function onMessage(event) {
        if (expectedOrigin && event.origin !== expectedOrigin) {
          return;
        }
        if (!isGhlSubmit(event.data)) {
          return;
        }

        window.removeEventListener('message', onMessage);

        var embed = dialog.querySelector('[data-ark-ghl]');
        var note = dialog.querySelector('[data-ark-note]');
        var thankyou = dialog.querySelector('[data-ark-thankyou]');
        if (embed) {
          embed.hidden = true;
          embed.style.display = 'none';
        }
        if (note) {
          note.hidden = true;
          note.style.display = 'none';
        }
        if (thankyou) {
          thankyou.hidden = false;
        }

        markSeen();

        if (autoclose > 0) {
          window.setTimeout(function () {
            dialog.close();
          }, autoclose * 1000);
        }
      }

      window.addEventListener('message', onMessage);
    }

    if (hasSeen()) {
      return;
    }

    // Trigger configuration.
    if (dialog.getAttribute('data-template') === 'cart') {
      return;
    }

    var isMobile = window.matchMedia('(max-width: 749px)').matches;
    var delaySeconds = parseFloat(dialog.getAttribute(isMobile ? 'data-delay-mobile' : 'data-delay'));
    if (isNaN(delaySeconds) || delaySeconds < 0) {
      delaySeconds = isMobile ? 30 : 15;
    }
    var acrossPages = dialog.getAttribute('data-delay-across-pages') === 'true';
    var CLOCK_KEY = 'ark_popup_t0';

    function remainingMs() {
      var ms = delaySeconds * 1000;
      if (!acrossPages) {
        return ms;
      }
      try {
        var t0 = parseInt(sessionStorage.getItem(CLOCK_KEY), 10);
        if (!t0) {
          t0 = Date.now();
          sessionStorage.setItem(CLOCK_KEY, String(t0));
        }
        return Math.max(0, ms - (Date.now() - t0));
      } catch (e) {
        return ms;
      }
    }

    function drawerIsOpen() {
      var d = document.querySelector('cart-drawer');
      return !!(d && d.classList.contains('active'));
    }

    function openWhenClear() {
      if (document.visibilityState !== 'visible') {
        document.addEventListener('visibilitychange', function onVisible() {
          if (document.visibilityState === 'visible') {
            document.removeEventListener('visibilitychange', onVisible);
            openWhenClear();
          }
        });
        return;
      }
      if (drawerIsOpen()) {
        var drawer = document.querySelector('cart-drawer');
        var observer = new MutationObserver(function () {
          if (!drawerIsOpen()) {
            observer.disconnect();
            // openWhenClear, not openOnce: a drawer reopened inside these 2 s defers the popup again.
            delayTimer = window.setTimeout(openWhenClear, 2000);
          }
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        return;
      }
      openOnce();
    }

    var scrollPercent = parseFloat(dialog.getAttribute('data-scroll-percent'));
    if (isNaN(scrollPercent)) {
      scrollPercent = 35;
    }

    var delayEnabled = dialog.getAttribute('data-delay-enabled') === 'true';
    var scrollEnabled = dialog.getAttribute('data-scroll-enabled') === 'true';
    var exitEnabled = dialog.getAttribute('data-exit-enabled') === 'true';

    if (delayEnabled) {
      // Never under one second: a page the shopper is already leaving should not flash it.
      delayTimer = window.setTimeout(openWhenClear, Math.max(1000, remainingMs()));
    }

    if (scrollEnabled) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    if (exitEnabled && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', onMouseOut);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ark-feature-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    function load(video) {
      if (video.dataset.loaded) return;
      video.dataset.loaded = '1';
      video.querySelectorAll('source[data-src]').forEach(function (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      video.load();
    }

    // One observer per root: the page on load, then each section the theme editor re-renders
    // (shopify:section:load hands over fresh video elements the first observer never saw).
    function init(root) {
      var videos = root.querySelectorAll('[data-ark-fp-video]');
      if (!videos.length) return null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            load(video);
            var p = video.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5] });
      videos.forEach(function (v) { io.observe(v); });
      return io;
    }

    var observers = new WeakMap();
    init(document);

    document.addEventListener('shopify:section:load', function (event) {
      var io = init(event.target);
      if (io) observers.set(event.target, io);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var io = observers.get(event.target);
      if (!io) return;
      io.disconnect();
      observers.delete(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ark-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initPromo(root) {
      var track = root.querySelector('.ark-promo__track');
      if (!track) return;
      var n = track.children.length;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Small screens are usually on metered mobile data — don't spend it
      // auto-pulling large slide images into view unless the merchant opts in.
      // Manual swipe still works either way.
      var isSmallScreen = window.matchMedia('(max-width: 749px)').matches;
      var autoplayMobile = root.getAttribute('data-autoplay-mobile') === 'true';
      var barsWrap = root.querySelector('.ark-promo__bars');
      var current = 0;
      var timer = null;
      var scrollDebounce = null;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && n > 1 && !reduce && (!isSmallScreen || autoplayMobile);
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
      var slideStart = 0;
      var elapsed = 0;
      var running = false;
      var fills = [];
      var adapt = root.classList.contains('ark-promo--adapt');

      // Write the fill's position directly; optionally animate the rest of the way.
      function setFill(i, fraction, animateMs) {
        var f = fills[i];
        if (!f) return;
        f.style.transition = 'none';
        f.style.transform = 'scaleX(' + fraction + ')';
        if (animateMs > 0) {
          void f.offsetWidth;
          f.style.transition = 'transform ' + animateMs + 'ms linear';
          f.style.transform = 'scaleX(1)';
        }
      }

      // "Adapt to image": slides can differ in height, so the track follows the
      // active slide instead of the tallest one (CSS clips the rest). The height
      // transition is enabled only after the first fit so load doesn't animate.
      function fitHeight() {
        if (!adapt) return;
        var s = track.children[current];
        if (!s) return;
        var h = s.offsetHeight;
        if (!h) return;
        track.style.height = h + 'px';
        if (!track.classList.contains('is-ready')) {
          window.requestAnimationFrame(function () { track.classList.add('is-ready'); });
        }
      }

      function paintBars() {
        fitHeight();
        if (!barsWrap) return;
        var b = barsWrap.children;
        for (var i = 0; i < b.length; i++) {
          var on = i === current;
          b[i].classList.toggle('is-active', on);
          b[i].setAttribute('aria-current', on ? 'true' : 'false');
          if (!on) setFill(i, 0, 0);
        }
        // Not autoplaying: the active bar is a static position indicator.
        if (!running) setFill(current, 1, 0);
      }

      function go(i, smooth) {
        current = (i + n) % n;
        fitHeight();
        track.scrollTo({ left: current * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
      }

      function clearTimer() {
        if (timer) { window.clearTimeout(timer); timer = null; }
      }

      function runCycle() {
        if (!autoplay) return;
        running = true;
        slideStart = performance.now() - elapsed;
        setFill(current, elapsed / interval, interval - elapsed);
        clearTimer();
        timer = window.setTimeout(function () {
          elapsed = 0;
          go(current + 1, true);
          paintBars();
          runCycle();
        }, Math.max(50, interval - elapsed));
      }

      function pause() {
        if (!running) return;
        running = false;
        elapsed = Math.min(interval, performance.now() - slideStart);
        clearTimer();
        setFill(current, elapsed / interval, 0);
      }

      function resume() {
        if (!autoplay || running) return;
        runCycle();
      }

      // Manual navigation: jump there, reset the cycle, keep autoplaying.
      function manualGo(idx) {
        elapsed = 0;
        go(idx, true);
        paintBars();
        if (autoplay) runCycle();
      }

      if (barsWrap && n > 1) {
        barsWrap.innerHTML = '';
        for (var i = 0; i < n; i++) {
          (function (idx) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'ark-promo__bar';
            b.setAttribute('role', 'tab');
            b.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
            var f = document.createElement('span');
            f.className = 'ark-promo__bar-fill';
            f.setAttribute('aria-hidden', 'true');
            b.appendChild(f);
            b.addEventListener('click', function () { manualGo(idx); });
            barsWrap.appendChild(b);
            fills.push(f);
          })(i);
        }
      }

      // Debounced: only read the landing position once scrolling settles, so the
      // smooth programmatic scroll's intermediate positions don't reset the cycle.
      track.addEventListener('scroll', function () {
        if (scrollDebounce) window.clearTimeout(scrollDebounce);
        scrollDebounce = window.setTimeout(function () {
          var w = track.clientWidth || 1;
          var idx = Math.round(track.scrollLeft / w);
          if (idx !== current) {
            current = idx;
            elapsed = 0;
            if (autoplay && running) runCycle();
          }
          paintBars();
        }, 120);
      }, { passive: true });

      window.addEventListener('resize', function () { go(current, false); fitHeight(); });

      if (adapt && window.ResizeObserver) {
        var ro = new ResizeObserver(function () { fitHeight(); });
        for (var r = 0; r < n; r++) ro.observe(track.children[r]);
      }

      if (autoplay) {
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', resume);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', resume);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) { pause(); } else { resume(); }
        });
        paintBars();
        runCycle();
      } else {
        paintBars();
      }

      // Editor + event API (theme-editor handlers below use this).
      root.__arkPromo = { go: go, pause: pause, resume: resume };
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-ark-promo]');
      for (var i = 0; i < roots.length; i++) { initPromo(roots[i]); }
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }

    // Theme editor: re-init after the editor re-renders the section (e.g. when a
    // slide is added), and reveal the slide the merchant selects — without these,
    // a newly added slide sits off-screen and looks like it vanished.
    document.addEventListener('shopify:section:load', function (e) {
      var roots = e.target.querySelectorAll('[data-ark-promo]');
      for (var i = 0; i < roots.length; i++) { initPromo(roots[i]); }
    });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target;
      if (!slide.classList || !slide.classList.contains('ark-promo__slide')) return;
      var root = slide.closest('[data-ark-promo]');
      if (!root || !root.__arkPromo) return;
      root.__arkPromo.pause();
      root.__arkPromo.go(Array.prototype.indexOf.call(slide.parentNode.children, slide), false);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var slide = e.target;
      if (!slide.classList || !slide.classList.contains('ark-promo__slide')) return;
      var root = slide.closest('[data-ark-promo]');
      if (root && root.__arkPromo) root.__arkPromo.resume();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ark-quote-strip"] && !Shopify.designMode) return;
  try {
    
function initArkQuotes(scope) {
  var roots = (scope || document).querySelectorAll('.ark-quotes');
  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.arkQuotesInit === 'true') return;
    root.dataset.arkQuotesInit = 'true';

    var list = root.querySelector('.ark-quotes__list');
    var items = Array.prototype.slice.call(root.querySelectorAll('.ark-quotes__item'));
    var dotsWrap = root.querySelector('.ark-quotes__dots');
    if (!list || !dotsWrap || items.length === 0) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantRotate = root.getAttribute('data-rotate') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var mqMobile = window.matchMedia('(max-width: 749px)');

    var pages = 1;
    var current = 0;
    var timer = null;
    var paused = false;

    function perView() { return mqMobile.matches ? 1 : 3; }

    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    function teardown() {
      stop();
      list.classList.remove('ark-quotes__list--rotating');
      items.forEach(function (item) {
        item.style.gridColumn = '';
        item.style.gridRow = '';
        item.classList.remove('is-active');
      });
      dotsWrap.hidden = true;
      dotsWrap.innerHTML = '';
    }

    function show(idx) {
      current = idx;
      var pv = perView();
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', Math.floor(i / pv) === idx);
      });
      Array.prototype.forEach.call(dotsWrap.children, function (dot, i) {
        dot.setAttribute('aria-current', i === idx ? 'true' : 'false');
      });
    }

    function start() {
      stop();
      timer = setInterval(function () {
        if (!paused && !document.hidden) show((current + 1) % pages);
      }, interval);
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < pages; i++) {
        (function (idx) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ark-quotes__dot';
          b.setAttribute('aria-label', 'Show reviews ' + (idx + 1) + ' of ' + pages);
          b.addEventListener('click', function () { show(idx); start(); });
          dotsWrap.appendChild(b);
        })(i);
      }
      dotsWrap.hidden = false;
    }

    function setup() {
      var pv = perView();
      if (!wantRotate || reduce || items.length <= pv) { teardown(); return; }
      pages = Math.ceil(items.length / pv);
      if (current >= pages) current = 0;
      list.classList.add('ark-quotes__list--rotating');
      list.style.setProperty('--per-view', pv);
      items.forEach(function (item, i) {
        item.style.gridRow = '1';
        item.style.gridColumn = String((i % pv) + 1);
      });
      buildDots();
      show(current);
      start();
    }

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    if (mqMobile.addEventListener) mqMobile.addEventListener('change', setup);
    setup();
  });
}

initArkQuotes(document);
document.addEventListener('shopify:section:load', function (e) { initArkQuotes(e.target); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      var slider = root.querySelector('.slider');
      if (!slider) return;
      var dotsEnabled = root.getAttribute('data-ark-dots') === 'true';
      var dragEnabled = root.getAttribute('data-ark-drag') === 'true';
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (dragEnabled) {
        slider.classList.add('ark-draggable');
        var isDown = false;
        var startX = 0;
        var startScroll = 0;
        var moved = false;
        var captured = false;
        var activePointer = null;
        var DRAG_THRESHOLD = 8;

        slider.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse') return;
          isDown = true;
          moved = false;
          captured = false;
          activePointer = e.pointerId;
          startX = e.clientX;
          startScroll = slider.scrollLeft;
        });
        slider.addEventListener('pointermove', function (e) {
          if (!isDown) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > DRAG_THRESHOLD) {
            moved = true;
            slider.classList.add('is-dragging');
            // Capture only once a real drag starts. Capturing on pointerdown
            // retargets the synthesized click to the slider, which swallows
            // left-click navigation on the product links inside it.
            try { slider.setPointerCapture(activePointer); captured = true; } catch (err) {}
          }
          if (moved) slider.scrollLeft = startScroll - dx;
        });
        function endDrag() {
          if (!isDown) return;
          isDown = false;
          slider.classList.remove('is-dragging');
          if (captured) { try { slider.releasePointerCapture(activePointer); } catch (err) {} captured = false; }
        }
        slider.addEventListener('pointerup', endDrag);
        slider.addEventListener('pointercancel', endDrag);
        slider.addEventListener('click', function (e) {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
            moved = false;
          }
        }, true);
        slider.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      if (dotsEnabled) {
        var dots = document.getElementById('ark-dots-' + root.getAttribute('data-id'));
        if (dots) {
          var blob = null;
          var maxScroll = function () { return Math.max(0, slider.scrollWidth - slider.clientWidth); };

          // One dot per scroll page, matching Dawn's "x / N" counter so the two never
          // disagree. Read the counter's total when it's been populated, otherwise
          // compute pages = items - perPage + 1 the same way Dawn does.
          var totalEl = root.querySelector('.slider-counter--total');
          var pageCount = function () {
            var fromCounter = totalEl ? parseInt(totalEl.textContent, 10) : 0;
            if (fromCounter > 0) return fromCounter;
            var slides = slider.children;
            if (slides.length < 2) return slides.length;
            var offset = slides[1].offsetLeft - slides[0].offsetLeft;
            var perPage = offset > 0 ? Math.round(slider.clientWidth / offset) : 1;
            return Math.max(1, slides.length - perPage + 1);
          };

          // Flow the violet pill across the dots by scroll progress. Pages are evenly
          // spaced, so a snapped page always lands the pill cleanly on a round dot; in
          // between, the leading edge (ease-out) runs ahead of the trailing edge
          // (ease-in) so the pill stretches to bridge the two dots, widest at f = 0.5.
          var positionBlob = function () {
            var btns = dots.querySelectorAll('.ark-carousel-dots__dot');
            var n = btns.length;
            if (!blob || n === 0) return;
            var ms = maxScroll();
            var progress = ms > 0 ? slider.scrollLeft / ms : 0;
            if (progress < 0) progress = 0;
            if (progress > 1) progress = 1;
            var floatIndex = progress * (n - 1);
            if (reduceMotion) floatIndex = Math.round(floatIndex);
            var lo = Math.floor(floatIndex);
            var hi = Math.min(n - 1, lo + 1);
            var f = floatIndex - lo;
            var r = (blob.offsetHeight || 11) / 2;
            var cLo = btns[lo].offsetLeft + btns[lo].offsetWidth / 2;
            var cHi = btns[hi].offsetLeft + btns[hi].offsetWidth / 2;
            var d = cHi - cLo;
            var easeIn = f * f;
            var easeOut = 1 - (1 - f) * (1 - f);
            var leftEdge = cLo + easeIn * d - r;
            var rightEdge = cLo + easeOut * d + r;
            blob.style.left = leftEdge + 'px';
            blob.style.width = rightEdge - leftEdge + 'px';
            var active = Math.round(floatIndex);
            for (var i = 0; i < n; i++) {
              if (i === active) { btns[i].setAttribute('aria-current', 'true'); }
              else { btns[i].removeAttribute('aria-current'); }
            }
          };

          var render = function () {
            var n = pageCount();
            if (n <= 1 || maxScroll() <= 0) {
              dots.style.display = 'none';
              return;
            }
            dots.style.display = '';
            var existing = dots.querySelectorAll('.ark-carousel-dots__dot').length;
            if (existing !== n) {
              dots.innerHTML = '';
              for (var i = 0; i < n; i++) {
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'ark-carousel-dots__dot';
                b.setAttribute('role', 'tab');
                b.setAttribute('aria-label', 'Go to page ' + (i + 1));
                (function (idx) {
                  b.addEventListener('click', function () {
                    var ms = maxScroll();
                    var count = dots.querySelectorAll('.ark-carousel-dots__dot').length;
                    var target = count > 1 ? (idx / (count - 1)) * ms : 0;
                    slider.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
                  });
                })(i);
                dots.appendChild(b);
              }
              // Blob is appended last so it paints atop the dot it covers.
              blob = document.createElement('span');
              blob.className = 'ark-carousel-dots__blob';
              blob.setAttribute('aria-hidden', 'true');
              dots.appendChild(blob);
            } else if (!blob) {
              blob = dots.querySelector('.ark-carousel-dots__blob');
            }
            positionBlob();
          };

          var ticking = false;
          slider.addEventListener('scroll', function () {
            if (!ticking) {
              ticking = true;
              window.requestAnimationFrame(function () { positionBlob(); ticking = false; });
            }
          }, { passive: true });
          window.addEventListener('resize', render);
          if ('ResizeObserver' in window) {
            var ro = new ResizeObserver(function () { render(); });
            ro.observe(slider);
          }
          render();
          window.setTimeout(render, 300);
          window.setTimeout(render, 1000);
        }
      }
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-ark-carousel]');
      for (var i = 0; i < roots.length; i++) { initCarousel(roots[i]); }
    }
    if (document.readyState !== 'loading') { initAll(); }
    else { document.addEventListener('DOMContentLoaded', initAll); }

    // Re-initialize when the theme editor re-renders this section (otherwise the
    // freshly rendered dots container stays empty after a setting change).
    document.addEventListener('shopify:section:load', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      var roots = e.target.querySelectorAll('[data-ark-carousel]');
      for (var i = 0; i < roots.length; i++) { initCarousel(roots[i]); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Background newsletter signup: no page reload, no anchor scroll-jump.
    // Falls back to the native post on captcha challenge or any ambiguity.
    var bindCopy = function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-nl-copy');
        var done = function () {
          var prev = btn.textContent;
          btn.textContent = 'Copied ✓';
          window.setTimeout(function () { btn.textContent = prev; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    };
    Array.prototype.forEach.call(document.querySelectorAll('[data-nl-copy]'), bindCopy);

    Array.prototype.forEach.call(document.querySelectorAll('form.newsletter-form'), function (form) {
      if (form.hasAttribute('data-nl-ajax')) return;
      form.setAttribute('data-nl-ajax', 'true');
      var wrap = form.parentElement;
      var success = wrap ? wrap.querySelector('[data-nl-success]') : null;
      if (!success || !window.fetch) return;

      var bypass = false;
      form.addEventListener('submit', function (e) {
        if (bypass) return;
        e.preventDefault();

        var fallback = function () {
          bypass = true;
          form.submit();
        };

        // URLSearchParams, not FormData: the endpoint expects the native form's
        // urlencoded body and rejects multipart with a 400 "invalid parameters".
        fetch(form.action, {
          method: 'POST',
          body: new URLSearchParams(new FormData(form)),
          headers: { Accept: 'text/html' },
          credentials: 'same-origin'
        })
          .then(function (res) {
            var showSuccess = function () {
              form.hidden = true;
              success.hidden = false;
              var h = success.querySelector('.newsletter-ajax-success__heading');
              if (h) h.focus({ preventScroll: true });
            };
            if (res.url.indexOf('customer_posted=true') !== -1) {
              showSuccess();
              return;
            }
            if (res.url.indexOf('challenge') !== -1) {
              fallback();
              return;
            }
            // Same-URL 200 can still be a challenge page — sniff before trusting.
            return res.text().then(function (html) {
              if (!res.ok || html.indexOf('shopify-challenge') !== -1 || html.indexOf('captcha') !== -1) {
                fallback();
              } else {
                showSuccess();
              }
            });
          })
          .catch(fallback);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
